import clsx from "clsx";
import type { PopoverProps as AriaPopoverProps } from "react-aria-components";
import { Menu as AriaMenu, Popover as AriaPopover, SubmenuTrigger as AriaSubmenuTrigger } from "react-aria-components";

import type { MenuProps } from "@/components/ui/Menu/Menu";
import { MenuItem } from "@/components/ui/Menu/MenuItem";

export type MenuPopoverProps = Pick<MenuProps, "items"> & AriaPopoverProps;

export const MenuPopover = ({ items, ...props }: MenuPopoverProps) => {
  return (
    <AriaPopover
      {...props}
      className={clsx("outline-none", props.className)}
    >
      <div className="overflow-hidden rounded-s border border-elevation-outline-1 bg-elevation-surface-1 shadow-5 outline-none">
        <AriaMenu>
          {items.map((item) =>
            !item.children || item.children.length === 0 ? (
              // oxlint-disable-next-line react/no-array-index-key
              <MenuItem
                key={item.label}
                {...item}
              />
            ) : (
              // oxlint-disable-next-line react/no-array-index-key
              <AriaSubmenuTrigger key={item.label}>
                <MenuItem {...item} />
                <MenuPopover
                  offset={0}
                  className="pl-2"
                  items={item.children}
                />
              </AriaSubmenuTrigger>
            ),
          )}
        </AriaMenu>
      </div>
    </AriaPopover>
  );
};
